import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m14.293 1.293-5 5 1.414 1.414 5-5-1.414-1.414Zm6 .5-5 5 1.414 1.414 5-5-1.414-1.414Zm1 5.5-5 5 1.414 1.414 5-5-1.414-1.414ZM8.11 16.718l1.398 4.58 2.315-4.193 4.788.092-3.267-3.5 1.565-4.528-4.348 2.032-3.81-2.88.59 4.739-3.934 2.75 4.703.908Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }